import avatar from '@/assets/flo/avatar.png';
import Constants from '@/Constants';
import { DialogFlowMessage } from '@/models/Chat';
import { getSelectedProfile } from '@/services/ProfileService';
import { ApplicationState } from '@/store';
import { completeChatSuccess, dismissBotAction, openChatModal, setUnreadMessages } from '@/store/bot/actions';
import React, { useEffect, useState } from 'react';
import { Popover } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ChatModal from '../ChatModal';
import ChatNotification from '../ChatNotification';
import AskToFavoriteContentAction from './AskToFavoriteContentAction';
import './style.scss';

const ChatBotFloatingButton: React.FC = () => {
    const { strings, user, person, openedChat, botAction, hasUnreadMessages, eventMessages, messageNotification } = useSelector(
        (state: ApplicationState) => ({
            strings: state.locale.data,
            user: state.identity.data.user,
            person: state.identity.data.person,
            openedChat: state.chat.openedChat,
            hasUnreadMessages: state.chat.hasUnreadMessages,
            eventMessages: state.chat.data.eventMessages,
            messageNotification: state.chat.data.eventMessages && state.chat.data.eventMessages[0] && state.chat.data.eventMessages[0].message,
            botAction: state.chat.action,
        }),
    );

    const dispatch = useDispatch();
    const history = useHistory();

    const [isVisible, setIsVisible] = useState<boolean>(false);
    const [showChatModal, setShowChatModal] = useState<boolean>(false);
    const [showNotification, setShowNotification] = useState<boolean>(false);

    const onClickChatButtonHandler = () => {
        dispatch(openChatModal());

        if (showNotification || hasUnreadMessages) {
            setShowNotification(false);
            dispatch(completeChatSuccess(({ chatbotMessagesData: eventMessages } as unknown) as DialogFlowMessage));
        }
    };

    const closeNotification = (showUnreadNotification: boolean = true) => {
        setShowNotification(false);
        dispatch(dismissBotAction());
        showUnreadNotification && dispatch(setUnreadMessages());
    };

    useEffect(() => {
        if (openedChat) {
            setShowChatModal(true);
        } else if (showChatModal) {
            setTimeout(function() {
                setShowChatModal(false);
            }, 500);
        }
    }, [openedChat]);

    useEffect(() => {
        setIsVisible(
            getSelectedProfile() !== Constants.HR_PROFILE &&
                strings._LANGUAGE === Constants.language.PT &&
                !history.location.pathname.match(/(profile|evaluations)/),
        );
    }, [strings._LANGUAGE, person.dynamicAttributes, user.profiles, history.location.pathname]);

    useEffect(() => {
        setShowNotification((!hasUnreadMessages && Boolean(messageNotification)) || Boolean(botAction));
    }, [hasUnreadMessages, messageNotification, botAction]);

    let popoverContent = null;
    let chatNotificationClassName = '';

    if (showNotification) {
        if (botAction) {
            chatNotificationClassName = 'chat-bot-popover-action';
            popoverContent = (
                <Popover.Content>
                    <AskToFavoriteContentAction closeNotification={() => closeNotification(false)} />
                </Popover.Content>
            );
        } else if (messageNotification) {
            popoverContent = (
                <Popover.Content onClick={onClickChatButtonHandler}>
                    <p>{messageNotification}</p>
                </Popover.Content>
            );
        }
    }

    if (!isVisible) {
        return null;
    }

    return (
        <>
            {showChatModal && <ChatModal />}
            <div className="chat-button-container">
                <ChatNotification
                    className={chatNotificationClassName}
                    closeNotification={closeNotification}
                    popoverContent={popoverContent}
                    showNotification={showNotification}
                >
                    <button className="btn btn-link" onClick={onClickChatButtonHandler}>
                        <img className="chat-avatar" src={avatar} />
                        {hasUnreadMessages && <div className="unread-indicator"></div>}
                    </button>
                </ChatNotification>
            </div>
        </>
    );
};

export default ChatBotFloatingButton;
